<div class="user-form" *ngIf="form">
  <form [formGroup]="form" (ngSubmit)="submit()">

    <input-field
      [label]="'forms.user.champs.nom' | translate"
      [controlName]="'nom'"
      [formGroup]="form"
      [labelPosition]="'stacked'"
      [type]="'text'"
    ></input-field>

    <input-field
      [label]="'forms.user.champs.prenom' | translate"
      [controlName]="'prenom'"
      [formGroup]="form"
      [labelPosition]="'stacked'"
      [type]="'text'"
    ></input-field>

    <input-field
      [label]="'forms.user.champs.adresseMail' | translate"
      [controlName]="'email'"
      [formGroup]="form"
      [labelPosition]="'stacked'"
      [type]="'email'"
    ></input-field>

    <input-field
      [label]="'forms.user.champs.telephone' | translate"
      [controlName]="'telephone'"
      [formGroup]="form"
      [labelPosition]="'stacked'"
      [type]="'tel'"
    ></input-field>

    <div class="form-field no-border-bottom">
      <div class="dep-label">{{'forms.user.champs.regimeAlimentaire' | translate}}*</div>
      <app-dep-field
        [disableFormBtn]="true"
        [depModel]="regimeModel"
        [value]="form.get('regime_id')?.value"
        (valueChange)="setRegimeValue($event)"
      ></app-dep-field>
    </div>
    <div *ngIf="this.form.get('regime_id')?.value" class="regime-desc">
      {{regimes[this.form.get('regime_id')?.value]}}
    </div>

    <!-- ================= ACTIONS ================= -->
    <ion-footer #footer>
      <div #actionsContainer class="actions-container">
        <button class="form-btn back-btn" type="button" (click)="previous()">{{'forms.btns.btnAnnuler' | translate}}</button>
        <button class="form-btn send-btn" type="submit">
          {{ id ? ('forms.btns.btnModifier' | translate) : ('forms.btns.btnCreer' | translate) }}
        </button>
      </div>
    </ion-footer>

  </form>
</div>
